// extracted by mini-css-extract-plugin
module.exports = {"emptyCell":"EmptyTableComponent_emptyCell__3a0cR"};